import { useAuth as useSharedAuth } from '@elka/hooks';
import { auth } from '@/lib/firebase/config';

export function useAuth() {
  return useSharedAuth({ auth });
}
